module.exports = __webpack_public_path__ + "static/media/trip-to-nowhere.730b16fb.jpg";